import { FormTemplate, Field, Constants, GenericEmailField, makeLabel, readOnlyField } from 'form-builder'
import { OpenInNewTab, OpenInSameTab } from '../App'

function ApplicationEmailField(props) {  // custom renderer
        const initialValue = props.field.patronData ? props.field.patronData : "";
        const label = makeLabel(props.field.label, props.field.required);
        const readOnly = readOnlyField(props.field, props.params);

        return (
            <GenericEmailField {...props} label={label} initialValue={initialValue} isReadOnly={readOnly}/>
        );
}


export class Template {
      
      
    static PATRONS_GROUP_NAME = "patronsgroup";  
    static LIMITED_PATRONS_GROUP_NAME = "limitedpatronsgroup";

    static PATRON_GROUP_NAME = "patrongroup";
    
    static APPLICATION_ADDRESS_FIELD_NAME = "address";   
   
    static PATRON_BIRTHDATE_FIELD_NAME = "patronBirthDate";
    static PATRON_IMAGE_FIELD_NAME = "patronImage";
    static PATRON_PRINT_PASS_SELECTION = "patronPrintPass";  
  
    static MEMBER_ASPECT_RATIO = 550/412;  
    
    
    static membershipTextFieldNames = [{label: "Address", name: Template.APPLICATION_ADDRESS_FIELD_NAME, required: true, type: "AddressField"},
                                       {label: "Primary Phone", name: "primaryPhone", required: false, type: "TextField"}, 
                                       {label: "Alternate Phone", name: "secondaryPhone", required: false, type: "TextField"}, 
                                       {label: "Email", name: "email", required: true, type: "EmailField"}, 
                                       {label: "Emergency Contact", name: "emergencyContact", required: false, type: "EmergencyContactField"}, 
                                       {label: "Notes", name: "notes", required: false, type: "TextField"}];

    
    static memberTextFieldNames = [{label: "First Name", name: "patronFirstName", required: true},
                                   {label: "Last Name", name: "patronLastName", required: true}, 
                                   {label: "Relation", name: "patronRelation", required: false}];
                                  
    
      
    name   
    type;               //Class type, for Jackson
    group;

    version;
    comment;
    
    fieldTree;
    fieldCalculations;
    constants;
  
    constructor(json) {
        if (json) { 
            this.name = json.name;
            this.group = json.group;
            this.version = json.version;
            this.type = json.type;
            this.comment = json.comment;
            
            if (json.fieldTree) {  //Field tree only populated when individual Template is pulled for editing
                this.fieldTree = json.fieldTree;
                this.fieldTree.isBase = true;           //mark this as the base of the tree
            }           
            
            if (json.fieldCalculations)
                this.fieldCalculations = json.fieldCalculations;
            else
                this.fieldCalculations = [];

            if (json.constants) 
                this.constants = new Constants(json.constants);
            else 
                this.constants = new Constants();
        }
    }
    
    
    //Prepares Template for saving as a new 
    copyToNew(newName) {
     
        this.name = newName;
        this.version = null;
    }
    

    //Call this method prior to posting the Template for upserting
    prepareForPost() {
        FormTemplate.processFieldsForUpload(this.fieldTree);
    }

    //Create a new template with an empty fieldTree, with the specified name
    static createNew(name) {
        
        const newTemplate = new Template();
        
        newTemplate.name = name;
        newTemplate.type = "Template";
        
        newTemplate.fieldTree = {type: "FieldGroup", name: "BaseFieldGroup", isBase: true, children: []};
        newTemplate.fieldCalculations = [];
        newTemplate.constants = new Constants();
        
        return newTemplate;
    }
    
    
    
    static createPatronsGroup(baseField, forLimited) {
        
        const groupName = forLimited ? Template.LIMITED_PATRONS_GROUP_NAME : Template.PATRONS_GROUP_NAME;

        //Check to see what already exists
        let existingCloningGroup = FormTemplate.findFieldByName(baseField, groupName);
        if (existingCloningGroup && existingCloningGroup.type !== "CloningFieldGroup")
            throw new Error("There is already an existing field named \"" + groupName + "\" but it is not the correct type (must be CloningFieldGroup)");
      
        if (existingCloningGroup && !existingCloningGroup.isSyncField)
            throw new Error("There is already an existing field named \"" + groupName + "\" but it does not sync with PoolPass)");
                    
        if (existingCloningGroup && existingCloningGroup.template)
            throw new Error("The field \"" + groupName + "\" already has an existing template for cloning");
       
        const prefix = forLimited ? "limited" : '';     // need to avoid duplicating field names, though the backend only uses "contains" to search for the suffix
                     
        //Create the template
        const patronGroup = {type: "FieldGroup", 
                             name: prefix + Template.PATRON_GROUP_NAME,
                             label: forLimited ? "Limited Patron" : "Patron",
                             required: false,                           
                             instructions: "Enter the information for this patron",
                             modifiable: false,
                             patronData: null,
                             isSyncField: true,
                             children: []};
        
        
        //Nothing exists, create the CloningFieldGroup
        if (!existingCloningGroup)
            existingCloningGroup = {type: "CloningFieldGroup",
                                    name: groupName,
                                    instructions: "Keep Pressing + to add the number of patrons in your family",
                                    isSyncField: true,
                                    label: forLimited ? "Limited Patrons" : "Patrons",
                                    maxChildren: null,
                                    minChildren: null,
                                    children: [],
                                    modifiable: false,
                                    required: false
                                   };
                   
        //Assign the template
        existingCloningGroup.template = patronGroup;
        
        //Create the Member children

           
        for (let textFieldName of Template.memberTextFieldNames) {
            const name = prefix + textFieldName.name;
            if (FormTemplate.findFieldByName(baseField, name))
                throw new Error("There is already an existing field named \"" + name + "\"");
        }
     
        let memberFields = [];
     
        for (let textFieldName of Template.memberTextFieldNames) {
            const name = prefix + textFieldName.name;
            let newField = FormTemplate.createNewField(baseField, "TextField");
            newField.name = name;
            newField.label = textFieldName.label;
            newField.required = textFieldName.required;
            newField.instructions = "Enter the Member " + newField.label;
            newField.modifiable = true;
            newField.isSyncField = true;
            memberFields.push(newField);
        }
        
        
        const bdFieldName= prefix + Template.PATRON_BIRTHDATE_FIELD_NAME;
        if (FormTemplate.findFieldByName(baseField, bdFieldName))
            throw new Error("There is already an existing field named \"" + bdFieldName + "\"");
        
        let birthdateField = FormTemplate.createNewField(baseField, "DateField");
        birthdateField.name = bdFieldName;
        birthdateField.label = "Member Birthdate";
        birthdateField.instructions = "Select the Member Birthdate";
        birthdateField.modifiable = true;
        birthdateField.isSyncField = true;
        birthdateField.mustBeInPast = true;
        memberFields.push(birthdateField);
        
        const imageFieldName = prefix + Template.PATRON_IMAGE_FIELD_NAME;
        if (FormTemplate.findFieldByName(baseField, imageFieldName))
            throw new Error("There is already an existing field named \"" + imageFieldName + "\"");
        
        let imageField = FormTemplate.createNewField(baseField, "ImageField");
        imageField.name = imageFieldName;
        imageField.label = "Member Image";
        imageField.instructions = "Select the Member Image";
        imageField.modifiable = true;
        imageField.aspectRatio = Template.MEMBER_ASPECT_RATIO;
        imageField.isSyncField = true;
        memberFields.push(imageField);
        
        const printFieldName = prefix + Template.PATRON_PRINT_PASS_SELECTION;
        if (FormTemplate.findFieldByName(baseField, printFieldName))
            throw new Error("There is already an existing field named \"" + printFieldName + "\"");
        
        let printField = FormTemplate.createNewField(baseField, "SelectField");
        printField.name = printFieldName;
        printField.label = "Pass Type";
        printField.instructions = "Does the Patron need an initial pass, replacement pass, or reactivated pass?";
        printField.modifiable = true;
        printField.patronData = "Initial";
        printField.selectableItems = ["Initial", "Replacement", "Reactivated"];
        printField.isSyncField = true;
        memberFields.push(printField);
        
        patronGroup.children = memberFields;
            
        return existingCloningGroup;
    }
    
    
    static createPPMembershipFields(baseField) {
        
     
        for (let textFieldName of Template.membershipTextFieldNames) {
            if (FormTemplate.findFieldByName(baseField, textFieldName.name))
                throw new Error("There is already an existing field named \"" + textFieldName.name + "\"");
        }
     
        let membershipFields = [];
     
        for (let textFieldName of Template.membershipTextFieldNames) {
            let newField = FormTemplate.createNewField(baseField, textFieldName.type);
            newField.name = textFieldName.name;
            newField.label = textFieldName.label;
            newField.instructions = "Enter the Membership " + newField.label;
            newField.modifiable = true;
            newField.required = textFieldName.required;
            newField.isSyncField = true;
            membershipFields.push(newField);
        }
        
        if (FormTemplate.findFieldByName(baseField, "type"))
            throw new Error("There is already an existing field named \"type\"");
        //Type Field is Select
        let typeField = FormTemplate.createNewField(baseField, "SelectField");
        typeField.name = "type";
        typeField.label = "Membership Type";
        typeField.instructions = "Select the Membership Type";
        typeField.modifiable = true;
        typeField.isSyncField = true;
        typeField.selectableItems = ["Single", "Family"];
        membershipFields.push(typeField);
        
        
        return membershipFields;
        
    }
    

    static createURLButtonField(baseField) {
        const newField = FormTemplate.createNewField(baseField, "ButtonField");
        newField.action = "VisitURL";       // this must be registered as a function in Field.js
        newField.instructions = null;
        newField.attribute1 = true;
        newField.attribute1Name = "Open in new Tab";
        return newField;
    }   


    // This must be called when the Frontend is initialized, so that the URLNewWindow action can be registered. The action opens the URL which is stored 
    // in the field's target property
    static registerButtonActions() {
        
        // Legacy button should still be supported
        Field.registerFunction("URLNewWindow", (field) => { 
            if (field.target) {
                let url = field.target;
                if (url.indexOf("http://") !== 0 && url.indexOf("https://") !== 0 && url.indexOf("mailto:") !== 0) {
                    url = "http://" + url;   //default to http if no protocol specified
                }
                OpenInNewTab(url); 
            }
        });

        Field.registerFunction("VisitURL", (field) => { 
            if (field.target) {
                let url = field.target;
                if (url.indexOf("http://") !== 0 && url.indexOf("https://") !== 0 && url.indexOf("mailto:") !== 0) {
                    url = "http://" + url;   //default to http if no protocol specified
                }
                if (field.attribute1)
                    OpenInNewTab(url); 
                else
                    OpenInSameTab(url); 

            }
        });
    }

    static createApplicationEmailField(baseField) {
        const newField = FormTemplate.createNewField(baseField, "EmailField");
        newField.type = "ApplicationEmail";     // create new type from EmailField
        newField.name = "applicationEmail";
        newField.label = "Application Email";
        newField.required = true;
        newField.instructions = "Enter the application email address";
        return newField;
    }

   

    static registerCustomFields() {
        FormTemplate.registerCustomFieldType({
            typeName: "ApplicationEmail",
            hasInstructions: true,
            hasLabel: true,
            mergeAllowed: true,
            webhookAllowed: true,
            isReadOnly: false,
            hasHideUnhideCalculation: true,
            urlSettable: true,
            customRenderer: ApplicationEmailField,
            stringForField: (field) => field.patronData,
            numberForField: () => Number.NaN
        });
    }
                
    
    //This function must return an array of available fields, each item in the array having a label, icon, and a callback function.  The callback function should
    //(a) create one or more new fields and (b) call the provided insertFunction to insert the array of new fields into the Template 
    //baseField is assumed to be the root of the Template field tree
    static getAvailableFields(baseField, insertFunc) {
          
        return [{label: "Text Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "TextField")] )},   //array of one field
                {label: "Address Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "AddressField")] )},   //array of one field
                {label: "Email Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "EmailField")] )},   //array of one field
                {label: "Numeric Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "NumericField")] )},   //array of one field
                {label: "Date Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "DateField")] )},   //array of one field
                {label: "Select Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "SelectField")] )},   //array of one field
                {label: "Checkbox Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "CheckboxField")] )},   //array of one field
                {label: "Image Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "ImageField")] )},   //array of one field
                {label: "Document Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "DocumentField")] )},   //array of one field
                {label: "Signature Field", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "SignatureField")] )},   //array of one field
                {label: "Static Image", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "StaticImageField")] )},   //array of one field
                {label: "Rich Text Label", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "RichTextHtmlField")] )},   //array of one field
                {label: "iFrame", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "IFrameField")] )},   //array of one field
                {label: "URL Button", icon: null, selectCallback: () => insertFunc( [Template.createURLButtonField(baseField)] )},   //array of one field
                {label: "Vertical Space", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "VerticalSpaceField")] )},   //array of one field
                null,
                {label: "Group", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "FieldGroup")] )},        //array of one field
                {label: "Paged Group", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "PagedFieldGroup")] )},        //array of one field
                {label: "Cloning Group", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "CloningFieldGroup")] )},   //array of one field
                null,
                {label: "Membership Fields", icon: null, selectCallback: () => insertFunc(Template.createPPMembershipFields(baseField))},   //array of all Membership fields
                {label: "Patrons Group", icon: null, selectCallback: () => insertFunc( [Template.createPatronsGroup(baseField, false)] )},     //array of one field
                {label: "Limited Patrons Group", icon: null, selectCallback: () => insertFunc( [Template.createPatronsGroup(baseField, true)] )},     //array of one field
                null,
                {label: "Application Email", icon: null, selectCallback: () => insertFunc( [Template.createApplicationEmailField(baseField)] )},
                {label: "Calculation Result", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "CalcResultField")] )},
                {label: "Inline Calculation", icon: null, selectCallback: () => insertFunc( [FormTemplate.createNewField(baseField, "InlineCalculationField")] )}
               ];
    }
    
}


